export function getCalendarDays(date) {
  const year = date.getFullYear()
  const month = date.getMonth()
  const firstDay = new Date(year, month, 1)
  const lastDay = new Date(year, month + 1, 0)
  
  const firstDayWeekDay = firstDay.getDay()
  const lastDayDate = lastDay.getDate()
  
  let days = []
  let week = []
  
  // 添加上月的日期
  const prevMonthLastDay = new Date(year, month, 0).getDate()
  for (let i = firstDayWeekDay - 1; i >= 0; i--) {
    week.push({
      date: new Date(year, month - 1, prevMonthLastDay - i),
      dayNumber: prevMonthLastDay - i,
      isOtherMonth: true
    })
  }
  
  // 添加本月的日期
  for (let i = 1; i <= lastDayDate; i++) {
    week.push({
      date: new Date(year, month, i),
      dayNumber: i,
      isOtherMonth: false
    })
    
    if (week.length === 7) {
      days.push(week)
      week = []
    }
  }
  
  // 添加下月的日期
  if (week.length > 0) {
    const nextMonthDays = 7 - week.length
    for (let i = 1; i <= nextMonthDays; i++) {
      week.push({
        date: new Date(year, month + 1, i),
        dayNumber: i,
        isOtherMonth: true
      })
    }
    days.push(week)
  }
  
  return days
} 